'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _paths = require('ifeis-isomorphic/lib/redux/actions/accounts/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/registrations/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/feiseanna/paths');

var _paths4 = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths5 = require('ifeis-isomorphic/lib/redux/actions/stages/paths');

exports.default = function (user_id, feiseanna) {
  return function (state) {
    var loading = { loadingFeisDay: true };

    var selectedFeisId = (0, _paths3.getSelectedDashboardFeis)(state);

    var preparedFeiseanna = feiseanna.map(function (f) {
      var myCompetitors = (0, _paths.getMyCompetitorsForFeis)(state, user_id, f.feis.id).map(function (c) {
        return _extends({}, c.toJS(), {
          events: ((0, _paths2.getRegistrationsForPerson)(state, f.feis.id, c.get('id')) || (0, _immutable.List)()).map(function (rid) {
            return (0, _paths4.getEvent)(state, rid);
          }),
          registrations: state.getIn(['feiseanna', 'persons', f.feis.id, c.get('id')]) || (0, _immutable.List)()
        });
      }).toJS();

      return {
        feis: f.feis,
        hasBalanceDueForFeis: f.balance > 0,
        myCompetitors: myCompetitors,
        stages: ((0, _paths5.getStages)(state, f.feis.id) || (0, _immutable.List)()).map(function (sid) {
          return {
            stage: (0, _paths5.getStage)(state, sid) || (0, _immutable.Map)(),
            events: (0, _paths5.getEventsOnStage)(state, sid) || (0, _immutable.List)()
          };
        })
      };
    });

    var selectedFeis = selectedFeisId && preparedFeiseanna.find(function (p) {
      return p.feis.id === selectedFeisId;
    });

    // if selected feis in undefined, that means user hasnt selected feis. return.
    if (!selectedFeis) {
      return {
        preparedFeiseanna: preparedFeiseanna,
        selectedFeis: selectedFeis,
        loadingFeisDay: false
      };
    }

    // we have a selected feis but competitors array is not ready.
    if (selectedFeis.myCompetitors.length === 0) {
      return _extends({
        preparedFeiseanna: preparedFeiseanna,
        selectedFeis: selectedFeis
      }, loading);
    }

    // registrations are not ready here.
    if (selectedFeis.myCompetitors.length > 0 && selectedFeis.myCompetitors.some(function (c) {
      return c.events.get('loading');
    })) {
      return _extends({
        preparedFeiseanna: (0, _immutable.List)(),
        selectedFeis: selectedFeis
      }, loading);
    }

    return {
      preparedFeiseanna: preparedFeiseanna,
      selectedFeis: selectedFeis,
      loadingFeisDay: false
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/feis-day/mapStateToController.js
// module id = 522
// module chunks = 0